import {TextField} from '@wandb/components';
import React, {useCallback} from 'react';

import {useUpdateChartTitle} from '../hooks/useUpdateChartTitle';
import {useMarimoSettingsStateContext} from './MarimoSettingsContextProvider';

export const PanelTitle = () => {
  const {config, updateConfig, unsetConfigField} =
    useMarimoSettingsStateContext();

  const unsetConfigFieldCallback = useCallback(() => {
    unsetConfigField('title');
  }, [unsetConfigField]);
  const updateConfigCallback = useCallback(
    (title: string) => {
      updateConfig({title});
    },
    [updateConfig]
  );

  const {value, onChange} = useUpdateChartTitle({
    defaultChartTitle: '',
    chartTitle: config.title,
    unsetConfigField: unsetConfigFieldCallback,
    updateConfig: updateConfigCallback,
  });

  return (
    <TextField
      label="Panel title"
      fullWidth
      value={value}
      onChange={onChange}
    />
  );
};
